<div class="driver-metrics-tabs-container">
  <div class="pb-[20px]">
    <app-tabs [tabs$]="tabs$" data-cy="driver-metrics-tabs"></app-tabs>
  </div>
  <router-outlet></router-outlet>
</div>
